const AX_INSTRUCTIONS_STATUS = {
    CURRENT: 'CURRENT',
    COMPLETED: 'COMPLETED',
    PENDING: 'PENDING',
}

export default AX_INSTRUCTIONS_STATUS
